/**
 * @description
 * Comparison operators, expressed as the JavaScript symbols they stand for.
 *
 * Used wherever a rule between two values has to be described as data rather than code —
 * e.g. `DateValidator.compare()`, which reads the operator **left to right, start first**:
 * `LessThan` means *start must be less than end*.
 */
export enum ComparisonOperator {

    /**
     * @description Left side must be strictly smaller (earlier) than the right side
     */
    LessThan = '<',

    /**
     * @description Left side must be smaller than or equal to the right side
     */
    LessThanOrEqual = '<=',

    /**
     * @description Left side must be strictly greater (later) than the right side
     */
    GreaterThan = '>',

    /**
     * @description Left side must be greater than or equal to the right side
     */
    GreaterThanOrEqual = '>=',

    /**
     * @description Both sides must resolve to the same value
     */
    Equal = '===',

    /**
     * @description Both sides must resolve to different values
     */
    NotEqual = '!==',
}

/**
 * @description Union type for comparison operator string literals
 */
export type ComparisonOperatorType = '<' | '<=' | '>' | '>=' | '===' | '!==';

/**
 * @description Union type for comparison operator that accepts both enum values and string literals
 */
export type IComparisonOperator = ComparisonOperator | ComparisonOperatorType;
